import { SVGProps } from 'react';

const PersonalBankAccount = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='128'
      height='128'
      viewBox='0 0 128 128'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_703_24345)'>
        <path
          d='M82 113.2H40C25.2 113.2 13 101.1 13 86.2002V44.2002C13 29.4002 25.1 17.2002 40 17.2002H82C96.8 17.2002 109 29.3002 109 44.2002V86.2002C109 101 96.9 113.2 82 113.2Z'
          fill='#C0F9FC'
        />
        <path
          d='M78.4 107.6H42.3C28.5 107.6 17.4 96.4002 17.4 82.7002V82.6002C17.4 68.8002 28.6 57.7002 42.3 57.7002H78.4C92.2 57.7002 103.3 68.9002 103.3 82.6002V82.7002C103.4 96.5002 92.2 107.6 78.4 107.6Z'
          fill='#8CE6F4'
        />
        <path
          d='M29.1 68.3003C38.8 57.8003 52.1 64.2003 66.3 64.6003L81.1 69.4003C86.5 70.9003 96.9 87.8003 100.2 92.2003C100.2 92.2003 93.7 87.7003 93.3 96.1003C93.3 97.0003 91.8 96.1003 91.8 97.1003C91.5 104.3 89.3 113.1 88.7 113.1L37.7 113.4L26 79.0003C25.6 74.1003 25.8 72.0003 29.1 68.3003Z'
          fill='#00ACF0'
        />
        <path
          d='M26.9 71.1004C26.9 71.1004 14.6 102.1 21.2 109.1C25.5 113.7 38.5 113.4 38.5 113.4L70.6 112.3C70.6 112.3 72.7 99.4004 66.3 96.2004C59.9 93.0004 39.4 91.9004 39.4 91.9004C39.4 91.9004 51.3 73.6004 47 70.4004'
          fill='#00ACF0'
        />
        <path
          d='M42.3 67.4004C42.6 67.9004 44.9 71.8004 44.9 78.2004C44.9 80.9004 44.5 84.0004 43.3 87.4004L36.4 107.7C36.3 108 36.5 108.2 36.7 108.3C37 108.4 37.2 108.2 37.3 108L44.2 87.7004C45.4 84.2004 45.8 80.9004 45.8 78.2004C45.8 71.2004 43.1 66.9004 43.1 66.9004C43 66.7004 42.6 66.6004 42.4 66.7004C42.2 66.9004 42.1 67.2004 42.3 67.4004Z'
          fill='#006FAD'
        />
        <path
          d='M55.5 63.6001C55.5 63.6001 60.9 71.8001 64.5 74.0001C68.1 76.1001 68.8 77.6001 68.8 77.6001C68.8 77.6001 64.5 76.8001 62.8 78.4001C61.1 80.0001 55.8 83.8001 55.8 83.8001L52.5 63.2001C52.4 62.3001 53.9 61.2001 54.5 61.8001L55.5 63.6001Z'
          fill='white'
        />
        <path
          d='M69.1 77.1001C69 77.1001 68.2 76.6001 66.8 76.6001C65.2 76.6001 63 77.2001 60.3 79.6001C58.1 81.6001 56.9 82.7001 56.2 83.2001C55.9 83.5001 55.7 83.6001 55.6 83.7001L55.5 83.8001H55.4L55.6 84.3001V83.8001C55.5 83.8001 55.4 83.8001 55.4 83.8001L55.6 84.3001L55.9 83.9001C55.8 83.8001 55.7 83.8001 55.6 83.8001V84.3001H56.1C56.1 84.2001 56 84.0001 55.9 83.9001L55.6 84.3001L56 84.6001C56 84.6001 56.1 84.5001 56.1 84.3001H55.6L55.9 84.7001C55.9 84.7001 55.9 84.7001 56 84.6001L55.6 84.3001L55.9 84.7001L56.1 84.5001L52.8 63.4001C52.8 63.1001 52.5 62.9001 52.2 63.0001C51.9 63.0001 51.7 63.3001 51.8 63.6001L55.1 84.4001L55.6 84.3001L55.3 83.9001L55.2 84.0001C55.2 84.0001 55.1 84.1001 55.1 84.3001C55.1 84.4001 55.2 84.6001 55.3 84.7001C55.4 84.8001 55.5 84.8001 55.6 84.8001C55.7 84.8001 55.8 84.8001 55.8 84.8001C55.9 84.8001 55.9 84.7001 55.9 84.7001C56 84.6001 56.2 84.4001 56.9 83.8001C57.6 83.2001 58.7 82.2001 60.6 80.5001C63.1 78.2001 65.1 77.7001 66.4 77.7001C67 77.7001 67.4 77.8001 67.7 77.9001C67.9 78.0001 68 78.0001 68 78.0001H68.1C68.3 78.1001 68.6 78.1001 68.8 77.8001C69.4 77.5001 69.3 77.2001 69.1 77.1001Z'
          fill='#E6E7E8'
        />
        <path
          d='M53.1 55.1001L52.9 61.3001C52.9 61.3001 56.4 70.5001 60.4 71.7001C64.4 72.9001 64.1 76.2001 64.1 76.2001L66.1 74.9001L69.9 71.0001L70.6 60.4001L53.1 55.1001Z'
          fill='#FFBC9D'
        />
        <path
          d='M64 76.2004C64 76.2004 68.8 75.3004 70.9 79.9004C71.2 80.5004 72 80.4004 72.2 79.8004L75.1 67.4004C75.5 66.2004 71 64.6004 70.1 65.4004L67.7 71.7004C67.7 71.7004 64.7 75.6004 64 76.2004Z'
          fill='white'
        />
        <path
          d='M67 76.3001C67 76.3001 69 76.6001 70.5 79.8001C70.7 80.3001 71.2 80.5001 71.7 80.5001C72.2 80.5001 72.7 80.2001 72.9 79.6001L75.7 67.6001C75.8 67.3001 75.6 67.1001 75.3 67.0001C75 66.9001 74.8 67.1001 74.7 67.4001L71.9 79.4001C71.9 79.5001 71.8 79.6001 71.7 79.6001C71.6 79.6001 71.5 79.6001 71.4 79.4001C69.7 75.8001 67.3 75.3001 67.2 75.3001C66.9 75.3001 66.7 75.4001 66.6 75.7001C66.5 76.0001 66.7 76.2001 67 76.3001Z'
          fill='#E6E7E8'
        />
        <path
          d='M77.2 27.0004C77.2 27.0004 82.1 40.4004 78.4 53.8004C74.6 67.5004 59.8 64.0004 54.8 60.8004C51.1 58.4004 50 56.8004 49.5 53.9004C48.9 50.9004 40.1 48.8004 39.6 38.4004C39.1 28.0004 58.7 8.00039 77.2 27.0004Z'
          fill='#FFBC9D'
        />
        <path
          d='M81 26.5002C83.2 18.1002 75.7 12.4002 60.1 12.0002C44.6 11.6002 43.6 23.4002 43.6 23.4002C43.6 23.4002 36.3 23.9002 37.9 37.7002C39.4 51.5002 49.7 55.0002 49.7 55.0002L47.8 43.7002C48.6 41.6002 50.1 25.8002 59.4 27.7002C68.7 29.6002 77.2 27.0002 77.2 27.0002L78 30.4002C78 30.3002 79.8 30.8002 81 26.5002Z'
          fill='#0A303A'
        />
        <path
          d='M53.1 48.8002C53.1 52.5002 50 55.4002 46.1 55.4002C42.2 55.4002 39.1 52.4002 39.1 48.8002C39.1 45.2002 42.2 42.2002 46.1 42.2002C50 42.1002 53.1 45.1002 53.1 48.8002Z'
          fill='#FFBC9D'
        />
        <path
          d='M60.2 45.7002C58.3 45.7002 56.7 44.1002 56.7 42.2002V38.2002C56.7 36.3002 58.3 34.7002 60.2 34.7002C62.1 34.7002 63.7 36.3002 63.7 38.2002V42.2002C63.8 44.1002 62.2 45.7002 60.2 45.7002Z'
          fill='#FFF7F3'
        />
        <path
          d='M62.4 40.0003C62.4 41.5003 61.2 42.7003 59.7 42.7003C58.2 42.7003 57 41.5003 57 40.0003C57 38.5003 58.2 37.3003 59.7 37.3003C61.2 37.3003 62.4 38.5003 62.4 40.0003Z'
          fill='#0A303A'
        />
        <path
          d='M59.5 39.0002C59.5 39.4002 59.1 39.8002 58.7 39.8002C58.3 39.8002 57.9 39.4002 57.9 39.0002C57.9 38.6002 58.3 38.2002 58.7 38.2002C59.1 38.2002 59.5 38.5002 59.5 39.0002Z'
          fill='#FFF7F3'
        />
        <path
          d='M74.9 45.3003C73 45.3003 71.4 43.7003 71.4 41.8003V37.8003C71.4 35.9003 73 34.3003 74.9 34.3003C76.8 34.3003 78.4 35.9003 78.4 37.8003V41.8003C78.4 43.7003 76.8 45.3003 74.9 45.3003Z'
          fill='#FFF7F3'
        />
        <path
          d='M77.1 39.7C77.1 41.2 75.9 42.4 74.4 42.4C72.9 42.4 71.7 41.2 71.7 39.7C71.7 38.2 72.9 37 74.4 37C75.9 37 77.1 38.3 77.1 39.7Z'
          fill='#0A303A'
        />
        <path
          d='M55.5 43.4001C55.5 43.4001 60.5 40.5001 65.3 43.2001C65.3 43.2001 64.1 46.6001 59.5 45.8001C55 45.1001 55.5 43.4001 55.5 43.4001Z'
          fill='#FFBC9D'
        />
        <path
          d='M69.4 43.2004C69.4 43.2004 74.4 40.3004 79.2 43.0004C79.2 43.0004 78 46.2004 73.4 45.5004C68.8 44.8004 69.4 43.2004 69.4 43.2004Z'
          fill='#FFBC9D'
        />
        <path
          d='M48.5 45.4004C48.5 45.4004 47.2 44.9004 45.6 44.9004C44.7 44.9004 43.7 45.1004 42.8 45.7004C41.9 46.3004 41.2 47.3004 40.8 48.9004C40.7 49.1004 40.9 49.3004 41.1 49.4004C41.3 49.5004 41.5 49.3004 41.6 49.1004C41.9 47.7004 42.6 46.9004 43.3 46.4004C44 45.9004 44.9 45.8004 45.6 45.8004C46.3 45.8004 46.9 45.9004 47.4 46.0004C47.6 46.1004 47.8 46.1004 48 46.2004L48.1 46.3004C48.3 46.4004 48.5 46.3004 48.6 46.1004C48.8 45.7004 48.7 45.5004 48.5 45.4004Z'
          fill='#0A303A'
        />
        <path
          d='M70.7 51.3C70.6 51.3 70 51.6 69.2 51.8C68.2 52 66.8 52.2 65.4 52.1C64.7 52 64 51.9 63.3 51.6C62.6 51.3 62 50.9 61.5 50.4C61.3 50.2 61 50.2 60.9 50.4C60.8 50.6 60.8 51 61 51.2C61.7 51.8 62.4 52.3 63.1 52.6C64.2 53.1 65.4 53.2 66.5 53.2C67.6 53.2 68.6 53 69.4 52.8C70.4 52.6 71 52.3 71.1 52.3C71.3 52.2 71.4 51.9 71.3 51.6C71.2 51.3 70.9 51.2 70.7 51.3Z'
          fill='#0A303A'
        />
        <path
          d='M72.3 31.2001C72.3 31.2001 72.4 31.1001 72.6 31.0001C72.9 30.8001 73.3 30.5001 73.8 30.4001C74.1 30.3001 74.3 30.3001 74.6 30.4001C74.9 30.4001 75.2 30.5001 75.5 30.8001C75.9 31.1001 76.4 31.0001 76.6 30.6001C76.9 30.2001 76.8 29.7001 76.4 29.5001C75.9 29.2001 75.4 29.0001 74.9 28.9001C74.1 28.8001 73.5 28.9001 72.9 29.1001C72.3 29.3001 71.9 29.6001 71.6 29.8001C71.3 30.0001 71.2 30.2001 71.2 30.2001C70.9 30.5001 70.9 31.0001 71.2 31.3001C71.5 31.5001 72 31.5001 72.3 31.2001Z'
          fill='#0A303A'
        />
        <path
          d='M57.6 31.5004C57.6 31.5004 57.9 31.2004 58.4 31.0004C58.6 30.9004 58.9 30.8004 59.1 30.7004C59.4 30.6004 59.6 30.6004 59.9 30.7004C60.2 30.8004 60.4 30.9004 60.7 31.1004C61.1 31.4004 61.6 31.3004 61.8 30.9004C62.1 30.5004 62 30.0004 61.6 29.8004C61.1 29.4004 60.6 29.2004 60.1 29.1004C59.6 29.0004 59.1 29.0004 58.6 29.1004C57.9 29.2004 57.4 29.5004 57 29.8004C56.6 30.1004 56.4 30.3004 56.4 30.3004C56.1 30.6004 56.1 31.1004 56.4 31.4004C56.8 31.7004 57.3 31.8004 57.6 31.5004Z'
          fill='#0A303A'
        />
        <path
          d='M67 43.7003C67 43.7003 70.7 43.0003 70.6 45.7003C70.5 48.4003 67.2 47.6003 67.2 47.6003'
          fill='#EE7988'
        />
        <path
          d='M74 39.2004C74 39.6004 73.6 40.0004 73.2 40.0004C72.8 40.0004 72.4 39.6004 72.4 39.2004C72.4 38.8004 72.8 38.4004 73.2 38.4004C73.7 38.4004 74 38.7004 74 39.2004Z'
          fill='#FFF7F3'
        />
        <path
          d='M51.2 58.2C51.2 58.2 52.3 59.8 54.5 61.3C56.7 62.9 59.9 64.4 64.1 64.4C64.4 64.4 64.6 64.2 64.6 63.9C64.6 63.6 64.4 63.4 64.1 63.4C60.1 63.4 57.1 61.9 55 60.4C54 59.7 53.2 58.9 52.7 58.4C52.4 58.1 52.3 57.9 52.1 57.7L52 57.5C51.8 57.3 51.5 57.2 51.3 57.4C51.1 57.7 51.1 58 51.2 58.2Z'
          fill='#E59E85'
        />
        <path
          d='M80.5 112.9C80.5 112.9 80.7 99.1004 82.9 98.1004C85 97.1004 99.3 98.0004 99.3 98.0004C99.3 98.0004 101.6 103 101.7 109.1C101.7 111.2 100 112.9 97.9 112.9H80.5Z'
          fill='#00ACF0'
        />
        <path
          d='M100.6 110.7C100.6 110.7 112.8 96.4001 112 85.2001C111.2 73.9001 97.3 87.8001 97.3 87.8001L88.9 99.1001C88.8 99.1001 96.4 112.8 100.6 110.7Z'
          fill='#00ACF0'
        />
        <path
          d='M70.8 97.8L89.5 97.7C90.2 97.7 90.8 97.5 91.3 97.3C91.5 97.2 91.7 97 91.9 96.9C94.3 95.1 94.8 90.7 94.5 89.1C94.5 89 94.5 89 94.4 88.9C94.4 88.8 94.3 88.8 94.3 88.7C94.3 88.7 94.3 88.7 94.3 88.6C94.3 88.5 94.2 88.4 94.2 88.3C94.2 88.2 94.1 88.1 94.1 88C94.1 88 94.1 87.9 94 87.9C94 87.8 93.9 87.7 93.8 87.6L93.7 87.5C93.7 87.4 93.6 87.4 93.6 87.3C93.5 87.2 93.5 87.1 93.4 87C93.4 86.9 93.3 86.9 93.3 86.8C93.2 86.5 93 86.3 92.8 86C92.8 86 92.8 86 92.8 85.9C92.7 85.7 92.6 85.5 92.4 85.3C89.8 81.2 85.7 75.3 85.7 75.3C85.7 75.3 79.6 74.5 74.8 74.4C69.2 74.3 71.5 70 71.5 70C71.5 70 83.1 69.4 86 69.6C89 69.9 95.9 75.4 95.9 75.4C95.9 75.4 91.4 62.8 90.4 57.4C89.3 52.1 94 52 94 52L103 77.8C103 77.8 100.9 59.6 100.8 56.3C100.7 53.1 104.8 53.3 104.8 53.3L108.2 77.2C108.2 77.2 110 67.8 111.1 64.6C112.1 61.3 115.4 63.1 115.4 63.1C115.4 63.1 113.7 76.5 113.1 85.5C113.1 85.6 113.1 85.7 113.1 85.8C113.1 85.9 113.1 85.9 113.1 86C113.1 86.1 113.1 86.2 113.1 86.4V86.5C113.1 86.6 113.1 86.8 113.1 86.9C113.1 87 113.1 87 113.1 87.1C113.1 87.2 113.1 87.3 113.1 87.4C113.1 87.5 113.1 87.5 113.1 87.6C113.1 87.7 113.1 87.8 113.1 88V88.1C113.1 88.2 113.1 88.4 113.1 88.5C113.1 88.8 113.1 89.1 113.1 89.4C113.1 89.4 113.1 89.4 113.1 89.5C113.1 89.6 113.1 89.8 113.1 89.9C113.1 90 113.1 90.2 113.1 90.3C113.1 90.6 113.1 90.8 113.1 91.1C113.1 91.2 113.1 91.3 113.1 91.4C113.1 91.4 113.1 91.4 113.1 91.5C113.1 91.6 113.1 91.7 113.1 91.8C113.1 91.9 113.1 91.9 113.1 92V92.1C113.1 92.2 113.1 92.3 113.1 92.4C113.1 92.5 113.1 92.6 113.1 92.8V96.7C113.1 105.9 105.6 113.4 96.4 113.4H92.9C91.7 111.6 92.1 111.3 88.6 107.8C88.5 107.7 88.4 107.6 88.3 107.5C86.4 105.9 82.9 105.3 79.6 104.6C79.5 104.6 79.3 104.5 79.2 104.5C78.7 104.4 78.3 104.3 77.9 104.2C77.7 104.2 77.6 104.1 77.4 104.1C77.2 104.1 76.9 104 76.7 103.9C76.6 103.9 76.5 103.8 76.3 103.8C76.1 103.7 75.8 103.7 75.6 103.6C75.5 103.6 75.3 103.5 75.2 103.5C74.5 103.3 73.7 103 73.2 102.7C73.2 102.7 73.2 102.7 73.1 102.7C72.9 102.6 72.7 102.5 72.5 102.3C72.4 102.2 72.3 102.1 72.1 102C70.9 100.9 70.5 99.9 70.5 99.1C70.4 98 70.8 97.8 70.8 97.8Z'
          fill='#FFBC9D'
        />
        <path
          d='M82.5 100.3L51.8 100.8C49.6 100.8 47.8 99.1003 47.8 96.9003L47.6 79.8003C47.6 77.6003 49.3 75.8003 51.5 75.8003L82.2 75.3003C84.4 75.3003 86.2 77.0003 86.2 79.2003L86.4 96.3003C86.4 98.5003 84.7 100.3 82.5 100.3Z'
          fill='#2891B5'
        />
        <path
          d='M83.5 99.2002L52.7 99.7002C50.5 99.7002 48.7 98.0002 48.7 95.8002L48.5 78.7002C48.5 76.5002 50.2 74.7002 52.4 74.7002L83.2 74.2002C85.4 74.2002 87.2 75.9002 87.2 78.1002L87.4 95.2002C87.4 97.3002 85.7 99.1002 83.5 99.2002Z'
          fill='#3EAFCE'
        />
        <path
          d='M82.8 97.1004L54 97.6004C52.6 97.6004 51.4 96.5004 51.4 95.1004L51.2 79.5004C51.2 78.1004 52.3 76.9004 53.8 76.9004L82.6 76.4004C84 76.4004 85.2 77.5004 85.2 78.9004L85.4 94.5004C85.3 95.9004 84.2 97.0004 82.8 97.1004Z'
          fill='#5DCEE8'
        />
        <path
          d='M85.4776 80.0099L51.0811 80.3867L51.1183 83.7864L85.5149 83.4095L85.4776 80.0099Z'
          fill='#3EAFCE'
        />
        <path
          d='M56.9 94.2003C58.115 94.2003 59.1 93.2153 59.1 92.0003C59.1 90.7853 58.115 89.8003 56.9 89.8003C55.685 89.8003 54.7 90.7853 54.7 92.0003C54.7 93.2153 55.685 94.2003 56.9 94.2003Z'
          fill='#3EAFCE'
        />
        <path
          d='M63 94.4005C64.215 94.4005 65.2 93.4155 65.2 92.2005C65.2 90.9855 64.215 90.0005 63 90.0005C61.785 90.0005 60.8 90.9855 60.8 92.2005C60.8 93.4155 61.785 94.4005 63 94.4005Z'
          fill='#3EAFCE'
        />
      </g>
      <defs>
        <clipPath id='clip0_703_24345'>
          <rect
            width='102.5'
            height='101.4'
            fill='white'
            transform='translate(13 12)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PersonalBankAccount;
